import React from 'react';
import { string, shape, number, object } from 'prop-types';

import DailyChangeCell, { DailyChangeSingleCell } from './DailyChangeCell';

import { Dollar } from 'components/shared/Text/Text';

const CashHoldingsRow = ({
  name,
  marketValue,
  dailyChange,
  className,
  colSpan = 1,
  singleCell,
  children
}) => (
  <tr className={className}>
    <td colSpan={colSpan} className="account-name-group">
      <div className="account-name">{name.accountName}</div>
    </td>
    <td />
    <Dollar element="td" className="account-balance e2e-market-value">
      {marketValue}
    </Dollar>
    {singleCell ? (
      <DailyChangeSingleCell {...dailyChange} />
    ) : (
      <DailyChangeCell {...dailyChange} />
    )}
    {children}
  </tr>
);

CashHoldingsRow.propTypes = {
  name: shape({
    accountName: string
  }),
  marketValue: number,
  dailyChange: object,
  className: string,
  colSpan: number
};

export default CashHoldingsRow;
